var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.baseClass, { [`${_vm.baseClass}--disabled`]: _vm.disabled }]},[_c('div',{class:[
      `${_vm.baseClass}__header`,
      {
        [`${_vm.baseClass}__header--with-extra-content`]:
          _vm.$slots.hasOwnProperty('header-extra-content'),
      },
    ]},[_c('BaseIdTogglePanelButton',{class:[`${_vm.baseClass}__title`, { [`${_vm.baseClass}__title--default`]: !_vm.$slots.default }],attrs:{"panel-id":_vm.uid,"disabled":_vm.disabled || !_vm.$slots.default},on:{"click":_vm.togglePanel},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("title"),_c('span',{staticClass:"eicon",class:[
            `${_vm.baseClass}__icon`,
            `${_vm.baseClass}__icon--${_vm.iconPosition}`,
            `${_vm.baseClass}__icon--${_vm.iconSize}`,
            {
              [`${_vm.baseClass}__icon--open`]: _vm.isPanelOpen,
            },
          ]},[_vm._v("\n          chevrondown\n        ")])]},proxy:true}],null,true)}),_vm._t("header-extra-content")],2),(_vm.$slots.default)?_c('BaseIdTogglePanel',{class:`${_vm.baseClass}__body`,attrs:{"start-open":_vm.startOpen,"animation":_vm.animation,"panel-id":_vm.uid}},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }